"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicBytesDataType = void 0;

var ethereum_types_1 = require("ethereum-types");

var ethUtil = require("ethereumjs-util");

var _ = require("lodash");

var blob_1 = require("../abstract_data_types/types/blob");

var constants_1 = require("../utils/constants");

var DynamicBytesDataType = /*#__PURE__*/function (_blob_1$AbstractBlobD) {
  _inherits(DynamicBytesDataType, _blob_1$AbstractBlobD);

  var _super = _createSuper(DynamicBytesDataType);

  function DynamicBytesDataType(dataItem, dataTypeFactory) {
    var _this;

    _classCallCheck(this, DynamicBytesDataType);

    _this = _super.call(this, dataItem, dataTypeFactory, DynamicBytesDataType._SIZE_KNOWN_AT_COMPILE_TIME);

    if (!DynamicBytesDataType.matchType(dataItem.type)) {
      throw new Error("Tried to instantiate Dynamic Bytes with bad input: ".concat(dataItem));
    }

    return _this;
  }

  _createClass(DynamicBytesDataType, [{
    key: "encodeValue",
    // Disable prefer-function-over-method for inherited abstract methods.

    /* tslint:disable prefer-function-over-method */
    value: function encodeValue(value) {
      // Encoded value is of the form: <length><value>, with each field padded to be word-aligned.
      // 1/3 Construct the length
      DynamicBytesDataType._sanityCheckValue(value);

      var valueBuf = ethUtil.toBuffer(value);
      var wordsToStoreValuePadded = Math.ceil(valueBuf.byteLength / constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
      var bytesToStoreValuePadded = wordsToStoreValuePadded * constants_1.constants.EVM_WORD_WIDTH_IN_BYTES;
      var lengthBuf = ethUtil.toBuffer(valueBuf.byteLength);
      var lengthBufPadded = ethUtil.setLengthLeft(lengthBuf, constants_1.constants.EVM_WORD_WIDTH_IN_BYTES); // 2/3 Construct the value

      var valueBufPadded = ethUtil.setLengthRight(valueBuf, bytesToStoreValuePadded); // 3/3 Combine length and value

      var encodedValue = Buffer.concat([lengthBufPadded, valueBufPadded]);
      return encodedValue;
    }
  }, {
    key: "decodeValue",
    value: function decodeValue(calldata) {
      // Encoded value is of the form: <length><value>, with each field padded to be word-aligned.
      // 1/2 Decode length
      var lengthBuf = calldata.popWord();
      var lengthHex = ethUtil.bufferToHex(lengthBuf);
      var length = parseInt(lengthHex, constants_1.constants.HEX_BASE); // 2/2 Decode value

      var wordsToStoreValuePadded = Math.ceil(length / constants_1.constants.EVM_WORD_WIDTH_IN_BYTES);
      var valueBufPadded = calldata.popWords(wordsToStoreValuePadded);
      var valueBuf = valueBufPadded.slice(0, length);
      var value = ethUtil.bufferToHex(valueBuf);

      DynamicBytesDataType._sanityCheckValue(value);

      return value;
    }
  }, {
    key: "getDefaultValue",
    value: function getDefaultValue() {
      return DynamicBytesDataType._DEFAULT_VALUE;
    }
  }, {
    key: "getSignatureType",
    value: function getSignatureType() {
      return ethereum_types_1.SolidityTypes.Bytes;
    }
  }], [{
    key: "matchType",
    value: function matchType(type) {
      return type === ethereum_types_1.SolidityTypes.Bytes;
    }
  }, {
    key: "_sanityCheckValue",
    value: function _sanityCheckValue(value) {
      if (typeof value !== 'string') {
        return;
      }

      if (!_.startsWith(value, '0x')) {
        throw new Error("Tried to encode non-hex value. Value must include '0x' prefix.");
      } else if (value.length % 2 !== 0) {
        throw new Error("Tried to assign ".concat(value, ", which is contains a half-byte. Use full bytes only."));
      }
    }
  }]);

  return DynamicBytesDataType;
}(blob_1.AbstractBlobDataType);

exports.DynamicBytesDataType = DynamicBytesDataType;
DynamicBytesDataType._SIZE_KNOWN_AT_COMPILE_TIME = false;
DynamicBytesDataType._DEFAULT_VALUE = '0x';